import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vendor-management',
  templateUrl: './vendor-management.component.html',
  styleUrls: ['./vendor-management.component.scss'],
})
export class VendorManagementComponent implements AfterViewInit {
  isModalOpen = false;
  hiringIds: any[] = [];
  private shouldScrollToTimesheet = false;

  constructor(private router: Router) {
    const nav = this.router.getCurrentNavigation();
    this.shouldScrollToTimesheet = !!nav?.extras?.state?.['scrollToTimesheet'];
  }

  ngAfterViewInit(): void {
    if (this.shouldScrollToTimesheet) {
      setTimeout(() => {
        document.getElementById('timesheet-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  }
  toggleModal(): void {
    this.isModalOpen = !this.isModalOpen;
  }
  navigateToQuarterlyFeedback(): void {
    this.router.navigate(['/vendor-management/quarterly-feedback']);
  }

  handleOptionClick(option: string): void {
    this.isModalOpen = false; // Close the modal
    if (option === 'open-positions') {
      this.router.navigate(['/hiring-manager']);
    } else if (option === 'raise-hiring-request') {
      this.router.navigate(['/hiring-manager/hiringrequest']);
    }
}
}